import React, { useCallback } from 'react';
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import styled from '@emotion/styled';

export enum ActiveSort {
  ASC = 'ASC',
  DESC = 'DESC',
}

interface TitleTableProps {
  title?: string;
  isSort?: boolean;
  activeSort?: ActiveSort;
  onChangeSort?: (value?: ActiveSort) => void;
}

export const TitleTable = (props: TitleTableProps) => {
  const { title, isSort, activeSort, onChangeSort } = props;

  const handleClickSort = useCallback(() => {
    if (onChangeSort) {
      if (activeSort === ActiveSort.ASC) {
        return onChangeSort();
      }
      if (activeSort === ActiveSort.DESC) {
        return onChangeSort(ActiveSort.ASC);
      }
      return onChangeSort(ActiveSort.DESC);
    }

    return null;
  }, [onChangeSort, activeSort]);

  return (
    <StyledContainerTitle onClick={handleClickSort} onKeyDown={handleClickSort} tabIndex={0}>
      <div className="column-sorters">
        <span className="column-title">{title}</span>
        {isSort && (
          <span className="column-sorter column-sorter-full">
            <span className="column-sorter-inner">
              <CaretUpFilled className={`${activeSort === ActiveSort.ASC ? 'active' : ''} column-sorter-up`} />
              <CaretDownFilled className={`${activeSort === ActiveSort.DESC ? 'active' : ''} column-sorter-down`} />
            </span>
          </span>
        )}
      </div>
    </StyledContainerTitle>
  );
};

const StyledContainerTitle = styled.div(`
  .column-title {
    position: relative;
    z-index: 1;
    flex: 1;
  }

  .column-sorters {
    display: flex;
    flex: auto;
    align-items: center;
    justify-content: space-between;
  }

  .column-sorters:after {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    content: '';
  }

  .column-sorter {
    margin-left: 4px;
    color: #bfbfbf;
    font-size: 0;
    transition: color 0.3s;
  }

  .column-sorter-inner {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  }

  .column-sorter-up,
  .column-sorter-down {
    font-size: 14px;
  }

  .column-sorter-up.active,
  .column-sorter-down.active {
    color: #1890ff;
  }

  .column-sorter-up + .column-sorter-down {
    margin-top: -0.3em;
  }

  .column-sorters:hover .column-sorter {
    color: #a6a6a6;
  }
`);
